<template>
  <div id="app">
    <div v-if="!isWeixin" class="weixin-wrapper">
      请在微信客户端中打开链接
    </div>
    <van-sticky>
      <Header v-if="isWeixin && showHeader" :key="$route.path" :dark="headerDark" :showTextLabel="headerLabelVisible" />
    </van-sticky>
    <router-view v-if="isWeixin" class="page_content" />
  </div>
</template>

<script>
import Header from "@/components/Header";
import { mapMutations } from "vuex";
import util from "@/libs/util.js";

export default {
  name: "App",
  components: {
    Header,
  },
  data() {
    return {
      headerDark: true,
      headerLabelVisible: true,
      headerText: "招贤纳士",
      isWeixin: false,
    };
  },
  computed: {
    showHeader() {
      const name = this.$route.name;
      return name === "LoginError" ? false : true;
    },
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler: function (newPath, oldPath) {
        if (newPath === oldPath || !newPath) {
          return;
        }
        this.headerDark = this.$route.meta.headerDark;
        if (newPath.startsWith("/job") || newPath.startsWith("/schedule")) {
          this.headerLabelVisible = true;
        } else {
          this.headerLabelVisible = false;
        }
        // 设置Header标签文字
        this.setLabelText(newPath.endsWith("social") ? "社会招聘" : "校园招聘");
      },
    },
  },
  created() {
    // 判断是否为公众号环境
    this.isWeixin =
      navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    if (!this.isWeixin) {
      util.title("卫宁招聘");
    }
  },
  mounted() {},
  methods: {
    ...mapMutations("header", ["setLabelText"]),
  },
};
</script>

<style>
/* 项目通用自定义样式 */
@import "~@/assets/style/index.css";

#app {
  font-family: PingFang SC, -apple-system, SourceHanSansCN-Normal, Avenir,
    Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin: 0;
}

body {
  margin: 0;
  -webkit-overflow-scrolling: touch;
  height: 100vh;
  overflow-x:hidden;
}

.weixin-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  color: #2c3e50;
  background: #f8f8f8;
}

/* 确认弹窗样式 */
.van-dialog.dialog-confirm {
  border-radius: 8px;
}

.van-dialog.dialog-confirm .van-dialog__message {
  font-size: 16px;
  color: #333;
  padding: 25px 0;
}

.van-dialog.dialog-confirm .van-dialog__content {
  min-height: 1em;
}

.van-dialog.dialog-confirm .van-dialog__footer .van-button__content {
  font-size: 16px;
  line-height: 44px;
}

.van-overlay {
  background-color: rgba(0, 0, 0, 0.4) !important;
}

.a-link,
.van-button--round,
.label,
.top-right-content-underway,
.top-right-content-end,
.schedule-tag,
.top-right-content-not-start,
.btn {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.van-tag {
  display: flex !important;
  align-items: center !important;
  text-align: center !important;
  justify-content: center !important;
  padding: 0 !important;
  line-height: 1px !important;
}
</style>
